import mixpanel from "mixpanel-browser"
import { DIAGNOSES_EVENTS } from "."

interface ClickOnDiagnosisSubthemeProps {
  startDate: string
  userName: string
  userEmail: string
  subthemeId: string
}

export function clickOnDiagnosisSubtheme(props: ClickOnDiagnosisSubthemeProps) {
  return mixpanel.track(DIAGNOSES_EVENTS.CLICK_ON_DIAGNOSIS_SUBTHEME, {
    ...props,
  })
}
